import { getValue } from '../utils/ConfigProvider'
import { DEFAULT_POSTCODE, isTu, hasVariants, isTuItem } from './Availability/AvailabilityTuHelper'

const CIS_COOKIE = 'cisId'
const FEATURE_TYPE_KEY = 'FT_'
const CHUNK_SIZE = getValue('features.availability.chunkSize')
const OUT_OF_STOCK_LABEL = {
  icon: 'out_of_stock',
  message: 'Out of stock'
}
const INFORMATION_LABEL = {
  icon: 'info',
  message: 'Check more options'
}

const checkItemAvailability = messageKey => {
  const unavailableKeys = ['OUT_OF_STOCK', 'NOT_AVAILABLE']
  const isUnavailable = unavailableKeys.some(key => messageKey.includes(key))

  return isUnavailable
}

const replaceIcon = availability => {
  const { messageKey = '', icon = '' } = availability || {}
  const replaceIconKeys = [
    'COLLECTION_FROM_TODAY_AT_TIME',
    'COLLECTION_FROM_TOMORROW_AT_TIME',
    'COLLECTION_FROM_DATE',
    'FT_30_DELIVERY'
  ]

  const isMatched = replaceIconKeys.some(key => messageKey.includes(key))

  return isMatched ? 'tick' : icon
}

// Split array into size chunks
const chunkArray = (arr, size) =>
  arr.length > size ? [arr.slice(0, size), ...chunkArray(arr.slice(size), size)] : [arr]

// Displays the product labels for delivery & collection
const formatAvailabilityMessages = (availability = {}, product = {}) => {
  const { collection = {}, delivery = {} } = availability || {}

  const collectionKey = collection?.messageKey || ''
  const deliveryKey = delivery?.messageKey || ''

  const collectionLabels = collection
    ? {
        icon: replaceIcon(collection || {}),
        message: collection.text || ''
      }
    : {}

  const deliveryLabels = delivery
    ? {
        icon: replaceIcon(delivery || {}),
        message: delivery.text || ''
      }
    : {}

  // Return only delivery messaging for Tu
  if (isTu) {
    return [{ ...deliveryLabels }]
  }

  const isCollectionUnavailable = checkItemAvailability(collectionKey)
  const isDeliveryUnavailable = checkItemAvailability(deliveryKey)

  if (isCollectionUnavailable && isDeliveryUnavailable) {
    return hasVariants(product) ? [INFORMATION_LABEL] : [OUT_OF_STOCK_LABEL] // If item is out of stock AND has variants then show information messaging
  }

  const isFeatureType = collectionKey.indexOf(FEATURE_TYPE_KEY) === 0 && deliveryKey.indexOf(FEATURE_TYPE_KEY) === 0

  // Both fufilment methods are available
  if (!isCollectionUnavailable && !isDeliveryUnavailable) {
    if (isFeatureType) {
      // Collection and delivery messages are same for feature type products, so show one
      return [collectionLabels || deliveryLabels]
    }
    return [collectionLabels, deliveryLabels]
  }
  // Then either one or both are unavailable
  return isDeliveryUnavailable ? [collectionLabels] : [deliveryLabels]
}

// Returns the localised postcode or a default postcode for TU
const getLocalisedPostcode = (localisationPostcode = '') => (isTu ? DEFAULT_POSTCODE : localisationPostcode)

// Adding a quantity to a list of products
const appendQuantity = (products = []) => {
  const productsWithQuantity =
    products.length > 0 ? products.filter(product => product?.id).map(product => `${product?.id}_1`) : ''

  return productsWithQuantity.toString()
}

const formatProducts = (products = []) => {
  const filteredProducts = products.filter(product => (isTuItem(product?.id) ? !hasVariants(product) : product?.id))
  const appendedProducts = appendQuantity(filteredProducts)

  return appendedProducts
}

// Formats and returns an array of objects with delivery and collection information
const renderAvailabilityMessages = (product = {}, availabilityLabels = []) => {
  const partNumber = product.id
  const availabilityLabel = availabilityLabels.find(label => label.partNumber === partNumber)
  if (availabilityLabel) {
    return formatAvailabilityMessages(availabilityLabel, product)
  }
  return []
}

export {
  appendQuantity,
  CIS_COOKIE,
  CHUNK_SIZE,
  chunkArray,
  formatAvailabilityMessages,
  formatProducts,
  renderAvailabilityMessages,
  getLocalisedPostcode
}
